module.exports = __webpack_public_path__ + "static/media/NGO_dms.d2b038c8.png";